<template>
    <v-simple-table dense>
        <thead>
            <tr>
                <th>Intervalo</th>
                <th v-for="d in dias" :key="d">{{ d }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(fila, intervalo) in matriz" :key="intervalo">
                <td>{{ intervalo.slice(0, 5) }}</td>
                <td v-for="d in dias" :key="d">{{ fila[d] !== null ? fila[d] : '-' }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: 'vistaMatriz',
    props: {
        matriz: Object,
        dias: Array
    }
};
</script>